import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const getTSIEncryptKeyApi = async (TSICode) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/currentDayTour/get-tsi-encrypt-key`,
    method: "post",
    headers: headers,
    data: { code: TSICode },
  };
  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
